const formatDateToIST = (date) => {
  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in ms
  const istDate = new Date(date.getTime() + istOffset);

  return istDate.toISOString().split('T')[0]; // returns 'YYYY-MM-DD'
};
export default formatDateToIST;